export enum ClaimCommunicationActivityTypeEnum {
  Email = 1,
  Letter = 2,
  PhoneCall = 3,
  Fax = 4,
}
